import React from 'react';
import empty from '../../images/profile/empty.png';

interface IEmptyComponent {
  content?: string;
  customClass?: string;
}
export const EmptyComponent = (props: IEmptyComponent) => {
  const { content = 'Danh sách trống', customClass } = props;
  return (
    <div
      className={`flex gap-4 w-full p-4 text-[#5D646F] flex-col justify-center items-center py-3 ${customClass}`}
    >
      <img src={empty} alt="empty" />
      <p className="text-sm">{content}</p>
    </div>
  );
};
